import { useContext } from 'react';
import { FeatureFlagsContext } from 'infrastructure/features/FeatureFlagsContext';

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export default useFeatureFlags;
